import React from 'react';

export const AdultsOnlySeatingPositionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M44.36 20.9199C44.16 20.4999 43.66 20.3199 43.24 20.5199C38.42 22.7199 35.76 28.5399 35.3 33.5799C35.14 34.7399 35.1 36.1799 35.04 37.5199C34.78 37.3599 34.54 37.2399 34.36 37.1399C33.02 36.4199 31.7 35.9599 30.44 35.6999H30.4C29.88 35.5799 29.34 35.5199 28.82 35.4999C19.5 34.7999 12.78 43.9599 12.74 54.3199C12.74 54.7999 13.4 55.0399 13.7 54.6599C18.16 50.3399 22.5 43.6999 28 43.2599C28.34 43.2599 28.66 43.3399 29 43.4199C29.02 43.4199 29.04 43.4199 29.06 43.4399C29.78 43.6599 30.56 44.0999 31.24 44.5199C32 44.9999 32.76 45.3999 33.48 45.6999C35.9 45.1399 38.44 44.8399 41.06 44.7799C42.44 43.1799 43.02 40.5399 42.44 37.0399L42.1 33.7599C41.72 29.5799 41.96 25.7599 44.32 21.6999C44.44 21.4599 44.48 21.1599 44.36 20.9199ZM34.82 40.1799C34.82 40.1799 34.84 40.1799 34.84 40.1599C34.82 40.2599 34.8 40.3199 34.82 40.1799Z"
        fill="#FF6AA0"
      />
      <path
        d="M39.38 19.38C42.0531 19.38 44.22 17.213 44.22 14.54C44.22 11.8669 42.0531 9.69995 39.38 9.69995C36.707 9.69995 34.54 11.8669 34.54 14.54C34.54 17.213 36.707 19.38 39.38 19.38Z"
        fill="#FF6AA0"
      />
      <path
        d="M26.18 22.0401C28.853 22.0401 31.02 19.8732 31.02 17.2001C31.02 14.5271 28.853 12.3601 26.18 12.3601C23.5069 12.3601 21.34 14.5271 21.34 17.2001C21.34 19.8732 23.5069 22.0401 26.18 22.0401Z"
        fill="#00A6ED"
      />
      <path
        d="M23.68 35.6801C20.98 36.5401 18.88 37.9201 17.38 39.7801C16.7 34.0801 18.22 28.1401 22.78 24.5001C23.38 23.9801 24.34 24.6001 24.12 25.3601C23.14 29.1801 23.04 32.5001 23.68 35.6801Z"
        fill="#00A6ED"
      />
      <path
        d="M53.62 55.6C44.74 49.96 41.5201 50.1 32.32 54.68C30.5 55.36 28.3001 55.68 26.2001 54.92C22.5201 53.16 21.72 51.04 20.3 48.4C22.22 46.3 24.22 44.6 26.9 43.98C27.38 44.86 27.8801 45.74 28.4401 46.6C29.0401 47.66 29.2201 47.58 29.0401 47.58C28.9401 47.54 28.9001 47.58 29.0401 47.6C29.2401 47.6 29.5601 47.56 30 47.44C36.5201 45 43.68 43.68 49.42 49C50.34 49.56 55.94 56.06 53.6 55.6H53.62Z"
        fill="#00A6ED"
      />
      <path
        d="M35.5 40.42C35.58 40.28 35.7 40.08 35.98 39.82C36.34 39.48 36.98 39.1401 37.52 39.0401C38.6 38.8401 38.82 39.1001 38.72 39.0401C37.84 38.3401 36.96 37.78 36.08 37.3C35.92 38.36 35.76 39.38 35.54 40.3C35.54 40.36 35.5 40.4 35.5 40.44V40.42Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
